import React from 'react';
import { OptimizedImage } from '../../common/OptimizedImage';
import star from '../../../assets/star.png';

interface TestimonialCardProps {
  imageFileName: string; 
  quote: string;    
  author: string;      
  location: string;   
}

// Single Testimonial Card Component
const TestimonialCard: React.FC<TestimonialCardProps> = ({ imageFileName, quote, author, location }) => {
  return (
    <div className="testimonial-item">
      <div className="bg-img-wrap">
        {/* OptimizedImage component to render the image */}
        <OptimizedImage fileName={imageFileName} />
      </div>
      <div className="rating-wrapper clearfix text-center">
        {/* Dynamically render 5 stars */}
        {[...Array(5)].map((_, index) => (
          <img src={star} alt="star" title="star" key={index} />
        ))}
      </div>
      <div className="text-center testimonial-txt">{quote}</div>
      <div className="testimonial-author text-center">{author}, {location}</div>
    </div>
  );
};

export default TestimonialCard;
